import React from "react";
import FormattedDate from "./FormattedDate";
import "./Weather.css";
import WeatherUnit from "./WeatherUnit";
import WeatherForecast from "./WeatherForecast";

export default function WeatherInfo(props) {
  return (
    <div>
      <h1>{props.data.city}</h1>
      <ul>
        <li className="list-unstyled">
          {" "}
          <FormattedDate date={props.data.date} />
        </li>
        <li className="list-unstyled text-capitalize">
          {props.data.description}
        </li>
      </ul>
      <div className="row mt-3">
        <div className="col-6 image-degree">
          <img
            className="weather-icon"
            src={`https://openweathermap.org/img/wn/${props.data.iconUrl}@2x.png`}
            alt="weather"
          ></img>
          <p>
            <WeatherUnit celsius={props.data.temperature} />
          </p>
        </div>
        <div className="col-6">
          <ul className="weather-list">
            <li>Precipitation: {props.data.precipitation}%</li>
            <li>Humidity: {props.data.humidity}%</li>
            <li>Wind: {Math.round(props.data.wind)} km/h</li>
          </ul>
        </div>
      </div>
      <WeatherForecast
        icon={props.data.iconUrl}
        coordinates={props.data.coordinates}
      />
    </div>
  );
}
